import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Spinner } from "react-bootstrap";
import ReactModal from "../Modal/Modal";
import { useStyle } from "../../Containers/HR/Pages/HRMSetup/Departments/department-styles";

const DeleteConfirmModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  message = "Are u sure you want to delete this item?",
  title = "Delete",
}) => {
  const classes = useStyle();

  return (
    <ReactModal
      open={show}
      setOpen={(open) => {
        if (!open) onClose();
      }}
      title={title}
      size={500}
    >
      <Typography sx={{ my: 2, color: "#394767", fontSize: "15px" }}>
        {message}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Button
            variant="contained"
            className={classes.cancelBtn}
            onClick={onClose}
            disabled={loading}
          >
            No
          </Button>
          <Button
            variant="contained"
            className={classes.createBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Yes"}
          </Button>
        </Box>
      </Box>
    </ReactModal>
  );
};

export default DeleteConfirmModal;
